export default __webpack_public_path__ + "static/media/agent-role-agent-grey.49dd9cbb.svg";